import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { getBackgroundColorByRatingSum } from '../helpers';
import { RATING_COUNT_LABELS } from '../constants';

const Points = () => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gridGap: 24 }}>
      {RATING_COUNT_LABELS.map(({ primary, value }) => (
        <Box sx={{ display: 'inline-flex', flex: 1, alignItems: 'center' }} key={primary}>
          <Box
            sx={{
              minWidth: 24,
              height: 24,
              borderRadius: '10em',
              mr: 1,
              bgcolor: getBackgroundColorByRatingSum(value),
            }}
          />

          <Typography noWrap>{primary}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export default Points;
